<ng-container
	class="bg-white"
	*ngIf="matterActivity$ | async as matterActivity"
>
	<div>
		<div>
			<ul class="flex flex-row-reverse items-center justify-start">
				<li
					*ngFor="let user of matterActivity.users; let i = index"
					class="user-icon"
					[class.active]="user.active"
					[class.overlay]="i < matterActivity.totalUsers - 1"
					(mouseover)="showUserDetailsMouseover(user)"
					(mouseout)="showUserDetailsMouseout()"
				>
					<div *ngIf="user.avatar; else showInitial">
						<div class="h-full w-full">
							<img class="block mx-auto rounded-full" [src]="user.avatar" />
						</div>
					</div>
					<ng-template #showInitial>
						<div>{{ user.firstInitial }}</div>
					</ng-template>
				</li>
			</ul>
		</div>

		<div class="relative">
			<div
				*ngIf="showUsersDropdown"
				class="userDetailsPopup dropdown min-w-max ng-star-inserted p-3 text-right top-2 w-full"
				(mouseover)="showUserDetailsMouseover()"
				(mouseout)="showUserDetailsMouseout()"
			>
				<div>{{ selectedUser.userName }}</div>
				<div class="text-xs">
					<div *ngIf="!selectedUser.active" class="text-grey">
						{{ selectedUser.lastUpdated | timeAgo }}
					</div>
					<div *ngIf="selectedUser.active" class="text-green">
						<span>Viewing now</span>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="flex flex-col justify-center">
		<app-top-nav-bar-button
			id="viewing-now"
			title="Viewing now"
			[num]="matterActivity.totalActiveUsers"
			(showing)="showViewHistoryDropdown = $event"
		>
			<div
				class="popup top-2 translate-y-0 -right-2 min-w-max border-grey-veryLight dropdown p-4 gap-1.5 flex-col-reverse"
			>
				<div
					*ngFor="let item of matterActivity.users"
					class="flex gap-3 align-middle"
				>
					<div
						*ngIf="!item.avatar"
						class="user-icon"
						[class.active]="item.active"
					>
						{{ item.firstInitial }}
					</div>
					<div
						*ngIf="item.avatar"
						class="user-icon"
						[class.active]="item.active"
					>
						<div class="h-full w-full">
							<img class="block mx-auto rounded-full" [src]="item.avatar" />
						</div>
					</div>
					<div class="justify-between">
						<span class="text-xs font-bold">{{ item.userName }}</span>
						<div class="text-xs">
							<div *ngIf="!item.active">{{ item.lastUpdated | timeAgo }}</div>
							<div *ngIf="item.active" class="flex gap-2 text-green">
								<span>Viewing now</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</app-top-nav-bar-button>
	</div>
</ng-container>
